import { useNavigate } from "react-router-dom";
import { BinsFromVolumeDataInterface } from "../../../../../../redux/interfaces/expedition.interface";
import { expeditionRoutes } from "../../../../../../router/routesConstants";
import CustomButton from "../../../../../../components/CustomButton";
import SvgIcon from "../../../../../../helpers/SvgIcon";
import { useAppDispatch } from "../../../../../../redux/hooks";
import {
  openDownloadBinModal,
  setSelectedBinFromVolume,
} from "../../../../../../redux/reducer/expedition.reducer";

function ShowBinsActionButtons({
  itemId,
  crudData,
}: {
  itemId: number;
  crudData: BinsFromVolumeDataInterface;
}) {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const handleShowScannedPackages = () => {
    navigate(
      `${itemId}/${expeditionRoutes.scannedPackages}?sn_bin=${
        crudData.sn_bin
      }&withProblems=${crudData.withProblems ?? ""}`,
    );
  };

  const handleDownloadVolume = () => {
    dispatch(setSelectedBinFromVolume(crudData));
    dispatch(openDownloadBinModal());
  };

  return (
    <div>
      {!crudData.withProblems ? (
        <CustomButton
          variant="contained"
          className="mt-1 me-1"
          tooltipTitle="Vezi colete"
          onClick={handleShowScannedPackages}>
          <SvgIcon type="SCANNED_BOX" fill="white" />
        </CustomButton>
      ) : (
        <CustomButton
          variant="contained"
          className="mt-1 me-1"
          tooltipTitle="Vezi colete neconforme"
          onClick={handleShowScannedPackages}>
          <SvgIcon type="UNSCANNED_BOX" fill="white" />
        </CustomButton>
      )}

      {crudData.status === 1 && (
        <CustomButton
          tooltipTitle="Descarca bin"
          variant="contained"
          className="mt-1 me-1"
          onClick={handleDownloadVolume}>
          <SvgIcon type="DOWNLOAD_CARGO" fill="white" />
        </CustomButton>
      )}
    </div>
  );
}

export default ShowBinsActionButtons;
